import {Component, OnInit} from '@angular/core';
import {PendingInvoicesUserPackageService} from '../../../shared/services/pending-invoices-user-package.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import * as moment from 'moment';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-pending-invoices',
  templateUrl: './pending-invoices.component.html',
  styleUrls: ['./pending-invoices.component.scss']
})
export class StockistUserPackagePendingInvoicesComponent implements OnInit {
  submitting = false;
  pendingInvoices = [];
  showSearch: any = false;
  searchForm: FormGroup;
  bsConfig: Partial<BsDatepickerConfig>;
  pagination = {
    page: 1,
    total: null,
    perpage: 15,
    pages: null
  };

  constructor(public pendingInvoicesUserPackageService: PendingInvoicesUserPackageService,
              private fb: FormBuilder) {
    this.bsConfig = Object.assign({}, {containerClass: 'theme-dark-blue', dateInputFormat: 'YYYY-MM-DD'}, {showWeekNumbers: false});
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh() {
    this.searchForm = this.fb.group({
      'user_id': [''],
      'invoice_no': [''],
      'total_amount': [''],
      'date': ['']
    });
    this.get();
  }

  get(params: any = {}) {
    params.page = this.pagination.page;
    params.perpage = this.pagination.perpage;
    this.submitting = true;
    this.pendingInvoices = [];
    this.pendingInvoicesUserPackageService.get(params).subscribe(data => {
      if (data && data['data'] && data['data'].length > 0) {
        this.pendingInvoices = data['data'];
        this.pagination = {
          page: data['pagination'].page,
          total: data['pagination'].total,
          perpage: data['pagination'].perpage,
          pages: data['pagination'].pages,
        };
        this.triggerScroll();
      } else {
        this.pendingInvoices = [];
      }
      this.submitting = false;
    }, error => {
      this.submitting = false;
    });
  }

  navigateTo(data) {
    window.open(data.invoice_url, '_blank')
  }

  markInvoice(event, data) {
    let params = {
      'id': data.id,
      'status': event.target.value
    };
    this.pendingInvoicesUserPackageService.updateStatus(params).subscribe(data => {
      this.get();
      this.submitting = false;
    }, error => {
      this.submitting = false;
    });
  }

  triggerScroll() {
    window.scrollTo(500, 500);
    window.scrollTo(500, 0);
  }

  onPageChange(page) {
    this.pagination.page = page;
    this.get();
  }

  search() {
    this.pagination = {
      page: 1,
      total: null,
      perpage: 15,
      pages: null
    };
    let params = {
      'user_id': (this.searchForm && this.searchForm.value) ? this.searchForm.value.user_id : '',
      'invoice_no': (this.searchForm && this.searchForm.value) ? this.searchForm.value.invoice_no : '',
      'total_amount': (this.searchForm && this.searchForm.value) ? this.searchForm.value.total_amount : '',
      'date': (this.searchForm && this.searchForm.value) ? moment(this.searchForm.value.date).format('YYYY-MM-DD') : ''
    };
    this.get(params);
  }
}
